import React, { ReactElement } from "react";
import logo from "./assets/logo.png";
import "./assets/App.css";

function App(): ReactElement {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Coming Soon.... <code>Joseph Skrzysowski...</code> reloaded.
        </p>
        <a
          className="App-link"
          href="https://josephskrzysowski.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Check it.
        </a>
      </header>
    </div>
  );
}

export { App as Component };
